import React, { Component } from 'react';
import { inject, observer } from "mobx-react";
import { toJS } from "mobx";
import { Row, Col, Table } from "antd";

@inject('store')
@observer
class RoomsRank extends Component {
    render() {
        const { occ, arr } = this.props.store.allHotel;
        const columns = [{
            title: '排名',
            key: '排名',
            dataIndex: 'index',
            width: 80,
            render: (text, record, i) => {
                return (
                    <div className={`rank rank${text}`}>{text}</div>
                )
            }
        }, {
            title: '酒店名称',
            dataIndex: 'name',
            key: 'name',
        }, {
            title: '出租率',
            dataIndex: 'occ',
            key: 'occ',
            width: 150,
            sorter: (a, b) => a.occ - b.occ,
            render: (text, record, i) => {
                return (
                    <span>{Number(text * 100).toFixed(4) + "%"}</span>
                )
            }
        }];
        const arrColumns = [{
            title: '排名',
            key: '排名',
            dataIndex: 'index',
            width: 80,
            render: (text, record, i) => {
                return (
                    <div className={`rank rank${text}`}>{text}</div>
                )
            }
        }, {
            title: '酒店名称',
            dataIndex: 'name',
            key: 'name',
        }, {
            title: '平均房价',
            dataIndex: 'arr',
            key: 'arr',
            width: 150,
            sorter: (a, b) => a.arr - b.arr,
            render: (text, record, i) => {
                return (
                    <span>￥{Number(text).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</span>
                )
            }
        }];
        const pagination = {
            total: occ.length,
            pageSize: 5
        };
        return (
            <div className="rooms">
                <Row>
                    <Col span={12}>
                        <div className="total_style">出租率排名 Occ Ranking</div>
                        <Table
                            className="rank-table "
                            columns={columns}
                            dataSource={toJS(occ)}
                            rowKey={(record, index) => record.id}
                            pagination={pagination}
                        />
                    </Col>
                    <Col span={12}>
                        <div className="total_style">平均房价排名 ADR Ranking</div>
                        <Table
                            className="rank-table "
                            columns={arrColumns}
                            dataSource={toJS(arr)}
                            rowKey={(record, index) => record.id}
                            pagination={pagination}
                        />
                    </Col>
                </Row>
            </div>
        );
    }
}

export default RoomsRank;


// WEBPACK FOOTER //
// ./src/components/BI/headquarters/RoomsRank.js